import React from 'react';
import { Paper, Typography, Box, useTheme } from '@mui/material';
import type { PaperProps } from '@mui/material';

type Props = {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  noPadding?: boolean;
  titleColor?: 'primary' | 'default';
} & PaperProps;

const ContentCard: React.FC<Props> = ({
  title,
  subtitle,
  children,
  action,
  noPadding = false,
  titleColor = 'default',
  sx,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        p: noPadding ? 0 : 3,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        ...sx
      }}
      {...rest}
    >
      {(title || action) && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: title ? 2 : 0,
            px: noPadding ? 3 : 0,
            pt: noPadding ? 3 : 0
          }}
        >
          {title && (
            <Box>
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  color:
                    titleColor === 'primary'
                      ? theme.palette.primary.main
                      : theme.palette.text.primary
                }}
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    mt: 0.5
                  }}
                >
                  {subtitle}
                </Typography>
              )}
            </Box>
          )}
          {action}
        </Box>
      )}
      <Box
        sx={{ px: noPadding && title ? 3 : 0, pb: noPadding && title ? 3 : 0 }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default ContentCard;
